module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "commonAjaxLoading"
    }
  }), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-694e0a94!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/app.pug
// module id = 1413
// module chunks = 1